import { PREFIX } from '../common/constants';

export const LOCAL_EMAIL_INPUT_KEY = `${PREFIX}_signUp_email_input`;
export const LOCAL_EMAIL_TIME_KEY = `${PREFIX}_signUp_email_time`;
export const LOCAL_EMAIL_PREV_COUNT_TIME = `${PREFIX}_singUp_email_count_time`;

export const LOCAL_PHONE_INPUT_KEY = `${PREFIX}_signUp_phone_input`;
export const LOCAL_PHONE_TIME_KEY = `${PREFIX}_signUp_phone_time`;
export const LOCAL_PHONE_PREV_COUNT_TIME = `${PREFIX}_singUp_phone_count_time`;

export const SIGN_EMAIL_TAB_KEY = 'sign.email.tab';
export const SIGN_PHONE_TAB_KEY = 'sign.phone.tab';

export const EMAIL_BIZTYPE = 'EMAIL_REGISTER';
export const PHONE_BIZTYPE = 'PHONE_REGISTER';

export const NAMESPACE = '$entrance_signUp';

export const REGISTER_STEP_ONE = 'one';
export const REGISTER_STEP_TWO = 'two';

export const CONTROL_AB_GROUP = 'registerPage_1';
export const EXPERIMENT_AB_GROUP = 'registerPage_2';
export const SIGNUP_AB_CONFIG = {
  param_name: 'registerPage',
  value_type: 'String',
};

export const SIGNUP_TYPE_CONFIG = {
  email: {
    validationType: 'EMAIL',
    recallAPI: 'postEmailRecall',
  },
  phone: {
    validationType: 'PHONE',
    recallAPI: 'postPhoneRecall',
  },
};
